<template>
  <div>
    <div v-if="confirm_answer || required_answer" id="mybg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <SubHeader :title="headerTitle" />
      <!-- //header -->

      <div
        id="container"
        style="-webkit-overflow-scrolling: touch;-ms-overflow-style: -ms-autohiding-scrollbar;"
        ref="container"
      >
        <section id="contents">
          <div class="surveyPop" v-if="required_answer">
            <h4>필수 질문에 응답하지 않았습니다.</h4>
            <div class="btnWrap">
              <a href @click.prevent="next_requiredQ" class="btn" title="확인">확인</a>
            </div>
          </div>

          <div class="surveyPop" v-if="confirm_answer">
            <h4>설문을 제출하시겠습니까?</h4>
            <div class="btnWrap">
              <a href @click.prevent="sendpaper_action" class="btn" title="확인">확인</a>
              <a href @click.prevent="cancel" class="btn btn2" title="취소">취소</a>
            </div>
          </div>

          <div class="surveyWrap">
            <div v-bind:key="item.id" v-for="item in items" :id="item.id">
              <TextItem :flag="flag" :item="item" v-if="item.viewType ==='TEXT'" />
              <ImageItem :flag="flag" :item="item" v-if="item.viewType ==='IMAGE'" />
            </div>

            <a @click.prevent="sendpaper" href class="submitbtn" title="설문 제출">
              <img src="@/assets/img/survey.png" alt="설문 제출" />제출
            </a>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->

      <footer id="footer" class>
        <!-- class : error 가 붙으면 경고 메세지 출력 -->
        <div class="state">{{answers_count}} / {{question_count}}개 완료</div>
        <div class="error">
          <img src="@/assets/img/error_info.png" alt="경고" /> 2,3번 필수 설문에 응답해식세요
        </div>
        <!-- error -->
      </footer>
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import * as R from "ramda";
import TextItem from "@/components/non/TextItem";
import ImageItem from "@/components/non/ImageItem";
import sideMixin from "@/components/SideMixin";
import { Constant } from "@/utils/const";
export default {
  mixins: [sideMixin],
  components: { SubHeader, TextItem, ImageItem },
  mounted: function() {
    let that = this;

    this.$nextTick(function() {
      setTimeout(() => {
        document.getElementById(that.first_id).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center"
        });
      }, 100);
    });
  },
  created() {
    let paper_id = this.$route.params.paperid;

    // this.$store.dispatch("loadPaper", paper_id);
    this.$store.dispatch("nonReset");

    this.$axios.get(Constant.PaperApi + "/" + paper_id).then(resp => {
      console.log(resp.data);
      this.headerTitle = resp.data.title;
      this.flag = resp.data.flag;
    });

    this.$store.dispatch("loadNonItemList", paper_id);
    let user_nick = localStorage.getItem("default_info");
    let url = `${this.$Constant.NonItemApply}?paper_id=${paper_id}&user_nick=${user_nick}`;
    let that = this;
    this.$axios.get(url).then(resp => {
      if (resp.data.length === 0) {
        that.$axios
          .post(this.$Constant.NonItemApply, {
            user_nick: user_nick,
            paper_id: paper_id,
            iscomp: "N",
            ptype: this.flag,
            etc: null
          })
          .then(k => {
            that.apply_id = k.data.id;
          });
      } else {
        that.apply_id = resp.data[0].id;
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    let paper_id = to.params.paperid;

    this.$store.dispatch("loadNonItemList", paper_id);
    let user_nick = localStorage.getItem("default_info");
    let url = `${this.$Constant.NonItemApply}?paper_id=${paper_id}&user_nick=${user_nick}`;
    let that = this;
    this.$axios.get(url).then(resp => {
      if (resp.data.length === 0) {
        that.$axios
          .post(this.$Constant.NonItemApply, {
            user_nick: user_nick,
            paper_id: paper_id,
            iscomp: "N",
            ptype: this.flag,
            etc: null
          })
          .then(k => {
            that.apply_id = k.data.id;
          });
      } else {
        that.apply_id = resp.data[0].id;
      }
    });
    next();
  },

  data() {
    return {
      required_answer: false,
      confirm_answer: false,
      apply_id: null,
      required_questions: [],
      headerTitle: "",
      first_id: "xx",
      flag: "" // quiz or poll
    };
  },
  computed: {
    answers_count() {
      return this.$store.state.non_answers.length;
    },
    question_count() {
      return this.$store.state.non_items.length;
    },
    items() {
      let k = this.$store.state.non_items;
      let idx = 0;
      let that = this;

      if (k.length > 0) {
        let logic = function(x) {
          let hasI = R.any(t => t.bogitype === "image")(x.Itemdetails);
          hasI ? (x.viewType = "IMAGE") : (x.viewType = "TEXT");

          if (that.flag === "quiz") {
            that.required_questions.push(x.id);
          } else {
            if (x.required) {
              that.required_questions.push(x.id);
            }
          }

          if (idx === 0) {
            that.first_id = x.id;
          }

          idx === 0 ? (x.first = true) : (x.first = false);
          idx + 1 === k.length ? (x.last = true) : (x.last = false);

          //save the next  item id for scroll to next question
          idx + 1 === k.length
            ? (x.next_item_id = null)
            : (x.next_item_id = k[idx + 1].id);

          let t_d = R.map(d => {
            d.chk = false;
            d.disabled = null;
            d.apply_log_id = null;

            if (d.image != null) {
              // console.log(d.image);
              // d.image = JSON.parse(d.image);
            }

            return d;
          }, x.Itemdetails);
          x.Itemdetails = t_d;

          idx++;
          x.idx = idx;
          x.apply_id = that.apply_id;
          x.apply_log_id = null;
          return x;
        };

        k = R.map(logic, k);
      }

      return k;
    }
  },
  methods: {
    next_requiredQ() {
      //todo:  move to next required question
      this.required_answer = false;
    },
    sendpaper() {
      //todo: check to fill required questions

      let users_answer = this.$store.state.non_answers;

      let _t = R.reject(x => {
        return R.includes(x, users_answer);
      }, this.required_questions);

      if (_t.length === 0) {
        this.confirm_answer = true;
      } else {
        this.confirm_answer = false;
        this.required_answer = true;
      }
    },
    cancel() {
      this.confirm_answer = false;
    },
    sendpaper_action() {
      let paper_id = this.$route.params.paperid;
      let user_nick = localStorage.getItem("default_info");
      let that = this;
      that.$axios
        .put(this.$Constant.NonItemApply + "/" + that.apply_id, {
          iscomp: "Y"
        })
        .then(k => {
          that.$router.replace("/non/fulllist/" + that.flag);
        });
    }
  }
};
</script>


<style lang="scss" >
#mybg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: block;
  z-index: 12;
}

.surveyWrap {
  padding: 325px 20px;
}
.survey {
  background: #ffffff;
  box-shadow: 5px 5px 6px 2px rgba(0, 0, 0, 0.3);
  padding: 25px;
  margin-bottom: 270px;
  border-radius: 10px;
}
.survey.last {
  margin-bottom: 0;
}
.surveyTitle h3 {
  color: #000000;
  font-size: 14px;
  position: relative;
  padding-left: 32px;
  min-height: 23.5px;
}
.surveyTitle .num {
  background: #efc774;
  color: #ffffff;
  text-align: center;
  border-radius: 100%;
  width: 23.5px;
  height: 23.5px;
  line-height: 23.5px;
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.surveyTitle .img {
  width: 100%;
  font-size: 0;
  padding-left: 32px;
  margin-top: 15px;
}
.surveyTitle .img img {
  width: 49%;
  margin-left: 2%;
  margin-top: 5px;
}
.surveyTitle .img img:nth-child(2n + 1) {
  margin-left: 0;
}
.surveyTitle .img img:nth-child(1),
.surveyTitle .img img:nth-child(2) {
  margin-top: 0;
}
.exampleWrap {
  padding-left: 32px;
  margin-top: 15px;
  font-size: 0;
}
.exampleWrap .example_list {
  margin-top: 15px;
}
.exampleWrap .example_list:first-child {
  margin-top: 0;
}
.exampleWrap .example_list label {
  color: #000000;
  position: relative;
  padding-left: 25px;
  width: 100%;
  text-align: left;
}

.exampleWrap .example_list label:before,
.exampleWrap .example_list label span {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.exampleWrap_thum {
  font-size: 0;
}
.exampleWrap_thum .example_list {
  width: 48%;
  display: inline-block;
  vertical-align: middle;
  margin-left: 4%;
}
.exampleWrap_thum .example_list:nth-child(2n + 1) {
  margin-left: 0;
}
.exampleWrap_thum .example_list:nth-child(1),
.exampleWrap_thum .example_list:nth-child(2) {
  margin-top: 0;
}
.exampleWrap_thum .example_list label img {
  width: 100%;
}

.survey_info {
  margin-bottom: 8px;
  line-height: 1em;
}
.survey_info span {
  height: 18px;
  line-height: 18px;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  color: #ffffff;
  font-size: 10px;
  margin-right: 2.5px;
  border-radius: 9px;
  padding: 0 10px;
}
.survey_info span.necessary {
  background: #ef747d;
}
.survey_info span.choice_n {
  background: #868686;
}

.exampleWrapBig {
  padding-left: 0;
}
.exampleinput input {
  height: 35px;
  border: 1px solid #f4f1f1;
  width: 100%;
  border-radius: 4.5px;
  color: #000;
  font-size: 14px;
  text-align: left;
  padding: 0 10px;
}
.exampleWrap .btnWrap {
  margin-top: 10px;
}
.exampleWrap .btnWrap a {
  border-radius: 4.5px;
  display: block;
  height: 35px;
  line-height: 35px;
  background: #136c68;
  text-align: center;
  color: #fff;
  font-size: 13px;
}
.survey a.btn.check {
  border-radius: 4.5px;
  display: block;
  height: 35px;
  line-height: 35px;
  background: #136c68;
  text-align: center;
  color: #fff;
  font-size: 13px;
  margin-top: 25px;
}

a.submitbtn {
  margin-top: 17px;
  border-radius: 9px;
  display: block;
  height: 45px;
  line-height: 45px;
  background: #193231;
  text-align: center;
  color: #fff;
  font-size: 14px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2);
}
a.submitbtn img {
  width: 25px;
  margin-right: 10px;
  margin-top: -2px;
}

/* survey pop */
.surveyPop {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
  background: #ffffff;
  z-index: 13;
  padding: 25px;
  border-radius: 10px;
  text-align: center;
  font-size: 0;
  display: block;
}
.surveyPop h4 {
  color: #666666;
  font-size: 14px;
}
.surveyPop a.btn {
  margin-top: 15px;
  width: 95px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #ffffff;
  font-size: 13px;
  background: #4087e8;
  border-radius: 5px;
  display: inline-block;
  margin-left: 5px;
}
.surveyPop a.btn:first-child {
  margin-left: 0;
}
.surveyPop a.btn2 {
  background: #9f9f9f;
}
</style>    